import SectionLandingPage, {
  SectionLandingLink,
} from "components/components/SectionLandingPage/SectionLandingPage";
import React from "react";
import routeConstants from "utils/routeConstants";

const links: SectionLandingLink[] = [
  {
    title: "Rolling system frequency",
    to: routeConstants.rollingSystemFrequency,
    description:
      "NESO continuously monitors the system frequency in real time to ensure the system demand and generation are in balance; in the GB " +
      "electricity system this equates to 50 Hertz (Hz).",
  },
  {
    title: "Temperature",
    to: routeConstants.temperature,
    description:
      "This report provides daily average GB temperature data (in Celsius) as well as reference temperatures (low, normal and high). " +
      "NESO use this data as part of the electricity demand forecasting process.",
  },
  {
    title: "Loss of load probability (LoLP) and de-rated margin",
    to: routeConstants.lolpdrm,
    description:
      "The LoLP is a measure of system reliability calculated by the System Operator (SO) for each Settlement Period. " +
      "The LoLP indicates the probability of insufficient capacity to meet the generation needs.",
  },
];

const Transmission: React.FC = () => (
  <SectionLandingPage
    title="Transmission"
    description={
      <>
        <p>
          The Transmission section provides real-time and historical data
          related to the high-voltage electricity network, providing a complete
          picture of the grid that moves power from generators to distribution
          networks and large consumers.
        </p>
        <p>
          This section provides data on system stability and resilience,
          including rolling system frequency, crucial temperature values, and
          the Loss of Load Probability (LoLP) to assess the grid&apos;s capacity
          to meet demand.
        </p>
      </>
    }
    links={links}
  />
);

export default Transmission;
